import { object, string } from "yup";
import PageBlock from "@page-js/Pages/Page/Editor/scripts/pageBlock";

export default class GoogleMap extends PageBlock {
  public getType(): string {
    return "GoogleMap";
  }

  protected init(): any {
    return {
      props: {
        title: "위치안내",
        address: "서울특별시 시청",
        address_detail: "3층 301호",
        phone_number: "02-1234-5678",
        email: "email@mail.com",
      },
      attrs: {},
    };
  }

  public validateOrThrow(): Promise<any> {
    const schema = object().shape({
      props: object()
        .shape({
          address: string().required().label("주소"),
          address_detail: string().nullable().label("상세주소"),
          phone_number: string().nullable().label("전화번호"),
          email: string().email().nullable().label("이메일"),
        })
        .label("옵션"),
      attrs: object().required().label("속성"),
    });

    return schema.validate(this.toJSON(), { abortEarly: false });
  }
}
